import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import Hours from '../../../smoothr-web-app-core/models/Hours';
import dayjs from 'dayjs';

@Component({
	selector: 'app-working-hours-modal',
	templateUrl: './working-hours-modal.component.html',
	styleUrls: ['working-hours-modal.component.scss'],
	standalone: false,
})
export class WorkingHoursModalComponent implements OnChanges {
	@Input() schedule: Hours[] = [];
	@Input() language: string = 'en';
	@Input() venueName: string;
	formattedHours: string[] = [];

	ngOnChanges(changes: SimpleChanges): void {
		if (changes['schedule'] || changes['language']) {
			this.formatOpeningHours();
		}
	}

	formatOpeningHours(): void {
		const formatted: { [key: string]: string[] } = {};

		// Group opening hours by weekday
		this.schedule.forEach(({ weekday, openedAt, closedAt }) => {
			const dayName = dayjs()
				.weekday(weekday + 1)
				.locale(this.language)
				.format('dd')
				.toUpperCase();
			const timeRange = `${dayjs(openedAt, 'HH:mm').format('HH:mm')} – ${dayjs(closedAt, 'HH:mm').format('HH:mm')}`;

			if (!formatted[dayName]) {
				formatted[dayName] = [];
			}
			formatted[dayName].push(timeRange);
		});

		// Generate result array for consecutive days with the same schedule
		const days = Object.keys(formatted);
		const times = Object.values(formatted).map(ranges => ranges.join(', ')); // Combine multiple slots
		const result: string[] = [];

		let startDay = days[0];
		let prevTime = times[0];

		for (let i = 1; i <= days.length; i++) {
			if (times[i] !== prevTime || i === days.length) {
				if (startDay !== days[i - 1]) {
					result.push(`${startDay} TO ${days[i - 1]}: ${prevTime}`);
				} else {
					result.push(`${startDay}: ${prevTime}`);
				}
				startDay = days[i];
				prevTime = times[i];
			}
		}

		this.formattedHours = result;
	}
}
